import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationEventSelectControlComponent } from './notification-event-select-control.component';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    NotificationEventSelectControlComponent,
  ],
  imports: [
    CommonModule,
    MatLegacyFormFieldModule,
    MatLegacySelectModule,
    ReactiveFormsModule,
  ],
  exports: [
    NotificationEventSelectControlComponent,
  ],
})
export class NotificationEventSelectControlModule {
}
